import { BlockTimeLegEnum } from '../enums/block-time-leg.enum';
import { BlockTimeLegControlsInterface } from '../interfaces/block-time-leg-controls.interface';

/** The facts that the user selects in add mode. The facts grid does not show them as text in add mode. */
export const BLOCK_TIME_ADD_MODE_SELECT_LABELS: readonly string[] = ['Trip #', 'Customer', 'Air vendor', 'Tail number'];

/** The hours form controls of each leg in add mode. */
export const BLOCK_TIME_LEG_CONTROLS: Readonly<Record<BlockTimeLegEnum, BlockTimeLegControlsInterface>> = {
  [BlockTimeLegEnum.ObRepo]: { placeControl: 'outboundReposition', hoursControl: 'obHours', isAirport: true },
  [BlockTimeLegEnum.LiveFlight]: { placeControl: 'routing', hoursControl: 'liveFlightHours', isAirport: false },
  [BlockTimeLegEnum.IbRepo]: { placeControl: 'inboundReposition', hoursControl: 'ibHours', isAirport: true },
};

/** The error text of an hours field with a negative value. */
export const BLOCK_TIME_HOURS_ERROR = 'Enter 0 or more hours.';

/** The error text of each empty required field. The text names the field, so the user can find it. */
export const BLOCK_TIME_FIELD_ERRORS = {
  tripID: 'Select a trip.',
  customer: 'Select a customer.',
  airVendor: 'Select an air vendor.',
  tailNumber: 'Select a tail number.',
  monthYear: 'Select the month and year.',
} as const;

/** The text for an empty value. */
export const BLOCK_TIME_EMPTY_VALUE = '—';

/** The text for an airport that FlightAware did not record. */
export const BLOCK_TIME_NOT_RECORDED = 'Not recorded';

/** The info text of the Billed hours field. */
export const BLOCK_TIME_BILLED_HOURS_INFO = 'This must match the vendor’s invoice exactly.';

/** The text next to a total that does not include the IB repo hours. */
export const BLOCK_TIME_NOT_COUNTED = 'Not counted until verified';

/** The title and the subtitle of each leg row. */
export const BLOCK_TIME_LEG_LABELS: Readonly<Record<BlockTimeLegEnum, { title: string; subtitle: string }>> = {
  [BlockTimeLegEnum.ObRepo]: { title: 'OB repo', subtitle: 'Outbound reposition' },
  [BlockTimeLegEnum.LiveFlight]: { title: 'Live flight', subtitle: 'Patient / organ leg' },
  [BlockTimeLegEnum.IbRepo]: { title: 'IB repo', subtitle: 'Inbound reposition' },
};

export const BLOCK_TIME_ESTIMATED_CARD_TITLE = 'Aviapages Estimated Hours';
export const BLOCK_TIME_ACTUAL_CARD_TITLE = 'FlightAware Actual Hours';
export const BLOCK_TIME_ESTIMATED_TOTAL_LABEL = 'Est. block hours';
export const BLOCK_TIME_ACTUAL_TOTAL_LABEL = 'Actual block time';

export const BLOCK_TIME_RECORD_MODAL_WIDTH = '1120px';
export const BLOCK_TIME_RECORD_MODAL_MAX_WIDTH = '95vw';

/** The smallest difference in hours that the variance pill shows. */
export const BLOCK_TIME_VARIANCE_THRESHOLD = 0.01;

/** The note in the actual card after a verification. The record save is separate from the verification. */
export const BLOCK_TIME_VERIFICATION_SAVED_NOTE =
  'The IB repo verification is saved. "Save changes" saves only the other changes in this record.';

/** The maximum length of the record note. */
export const BLOCK_TIME_NOTE_MAX_LENGTH = 500;
